// BUNDLED: pdp-bundle.js
export default function() {
	jQuery(function($) {
		CCRZ.pubSub.on('view:productDetailView:refresh', async function() {
			const prodID = CCRZ.productDetailModel.attributes.product.prodBean.id;
			const prodShowFBT = CCRZ.productDetailModel.attributes.showFrequentlyBoughtTogether;
			if (!prodID || !prodShowFBT) return;

			try {
				const recommendClient = algoliasearch(
					CCRZ.quickSearchParams.algoliaAppId,
					CCRZ.quickSearchParams.algoliaSearchKey
				)

				const response = await recommendClient.getRecommendations([
					{
						indexName: CCRZ.quickSearchParams.algoliaMainProductIndex,
						objectID: prodID,
						model: 'bought-together',
						threshold: 0,
						maxRecommendations: 3,
						queryParameters: {
							filters: `price.${CCRZ.quickSearchParams.priceKey}.sale > -1`
						}
					}
				]);

				const recommendations = response.results?.[0]?.hits?.map(hit => ({
					...hit,
					price: hit.price[CCRZ.quickSearchParams.priceKey]
				})) || [];

				const template = CCRZ.util.template('PDP-Frequently-Bought');
				$('#PDPFrequentlyBought').html(template({recommendations}));
				const swiper = new Swiper('#PDPFrequentlyBought .swiper', {
					spaceBetween: 10,
					slidesPerView: 2,
					scrollbar: {
						enabled: true,
						draggable: true,
						el: '#PDPFrequentlyBought .swiper-scrollbar'
					},
					breakpoints: {
						768: {
							spaceBetween: 24,
							slidesPerView: 3
						}
					}
				});

			} catch (error) {
				console.error('Error fetching recommendations:', error);
				$('#PDPFrequentlyBought').empty();
			}
		});
	});
}
